<template>
  <div class="wohneinheit">

    <template v-if="zwselected">
      <div class="semanticsection-title2">
          <span class="primary--text ueber">Zweit-/Ferienwohnung</span>
      </div>

      <wohn-einheit :state-path="`${statePath}.zweitwohnung`" />
    </template>

    <template v-if="vermselected">
      <div class="semanticsection-title2">
        <span v-if="vermwohnungen.length > 1"
              class="primary--text ueber">Vermietete Wohneinheiten</span>
        <span v-else
              class="primary--text ueber">Vermietete Wohneinheit</span>
      </div>

      <template v-for="(vermwohnung, index) in vermwohnungen">

        <div :key="index">
            <div :class="index===0 ? 'first' : ''"
                 class="we--ueber">
              <span class="secondary--text subueber">{{ vermwohnung.beschreibung }}</span> <br>
              <span class="secondary--text">{{ "Miete: " + vermwohnung.bruttojahresmiete + " €,  " + "Beitrag: " + $helpers.toGermanFloatString(praemieForWohnung(vermwohnung)) + " €" }} </span>
            </div>

            <wohn-einheit
              :state-path="`${statePath}.vermwohnungen.${index}`" />
        </div>

      </template>
    </template>
  </div>
</template>

<script>
import WohnEinheit from "@/components/privatkundenrechner/Wohneinheit.vue";
import {mapTwoWay} from "@/store/twowayBindingMixin";
import twowayBinding from "@/store/twowayBindingMixin";
import ValidationMixin from "@/components/helper/ValidationMixin";

export default {
  name: "Wohneinheiten",
  components: { WohnEinheit },
  mixins: [twowayBinding, ValidationMixin],
  computed: {
    ...mapTwoWay([
      "vermselected",
      "vermwohnungen",
      "zweitwohnung",
      "zwselected"
    ]),
    currentVermieterPraemien() {
      return this.$store.getters.currentPraemien(this.statePath).vermieter;
    }
  },
  methods: {
    praemieForWohnung(wohnung) {
      return this.currentVermieterPraemien.find(vermPraemien => vermPraemien.id === wohnung.id).praemie;
    }
  }
};
</script>

<style>
.wohneinheit .we--ueber:not(.first) {
  margin-top: 40px !important;
}

.wohneinheit .we--ueber {
  margin-bottom: 24px !important;
}
</style>
